/**
 * Created by matthew on 2016/12/11.
 */
import axios from 'axios'

const instance = axios.create({
  // baseURL: process.env.NODE_ENV === "development" ? 'http://sportraxs.test/api/tracking/' : 'https://app.sportraxs.com/api/tracking/',
  baseURL: 'https://live.sportraxs.com/api/',
  timeout: 20000
})

export default {
  getEvent (eventId, cb, errCb) {
    instance.get('events/' + eventId)
      .then(function (response) {
        cb(response.data)
      })
      .catch(function (error) {
        errCb(error)
        console.log(error)
      })
  },

  getRace (raceId, cb) {
    instance.get('races/' + raceId)
      .then(function (response) {
        cb(response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  },

  getRaceAthletes(raceId, cb) {
    instance.get('races/' + raceId + '/athletes')
      .then(function (response) {
        cb(response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  },

  getRaceAthlete(athleteId, cb) {
    return instance.get('athletes/' + athleteId)
      .then(function (response) {
        cb(response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  },

  getRaceCheckpoints(raceId, cb) {
    instance.get('races/' + raceId + '/checkpoints')
      .then(function (response) {
        cb(response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  },

  getRaceRoute(raceId, cb) {
    instance.get('races/' + raceId + '/route')
      .then(function (response) {
        cb(response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  },

  getRaceRouteProfile(raceId, cb) {
    instance.get('races/' + raceId + '/route/profile')
      .then(function (response) {
        cb(response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
}



// WEBPACK FOOTER //
// ./src/store/api/index.js